export default __webpack_public_path__ + "static/idea-568bc32a97685ac56f91db46e7883158.svg";